import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Toast from '../../components/Toast';
import './AdminLoginPage.css';

function AdminLoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!username.trim() || !password.trim()) {
      setToast({ message: 'Please enter username and password', type: 'error' });
      return;
    }

    setLoading(true);

    // Simulate API delay
    setTimeout(() => {
      const result = login(username, password);
      
      if (result.success) {
        setToast({ message: result.message, type: 'success' });
        setTimeout(() => {
          // Redirect based on role
          if (result.role === 'superadmin') {
            navigate('/superadmin');
          } else {
            navigate('/admin');
          }
        }, 500);
      } else {
        setToast({ message: result.message, type: 'error' });
        setPassword('');
      }
      
      setLoading(false);
    }, 500);
  };

  return (
    <div className="admin-login-wrapper">
      {toast && (
        <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />
      )}

      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h1>Admin Login</h1>
            <p>Corn Bliss Order Management</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter your username"
                disabled={loading}
                autoFocus
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                disabled={loading}
              />
            </div>

            <button 
              type="submit" 
              className="btn-login" 
              disabled={loading}
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <div className="login-footer">
            {/* <p className="demo-credentials">
              <strong>Demo Credentials:</strong><br />
              <span style={{ fontSize: '0.9rem' }}>
                Admin: <code>admin</code> / <code>admin123</code><br />
                Superadmin: <code>superadmin</code> / <code>super123</code>
              </span>
            </p> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminLoginPage;
